export interface SongNote {
  note: string;
  time: number;
  velocity?: number;
}

export interface Song {
  id: string;
  title: string;
  notes: SongNote[];
}

// Nhemamusasa - one of the most famous traditional mbira pieces
// Simplified kushaura (lead) part
const NHEMAMUSASA: SongNote[] = [
  // Cycle 1
  { note: "G3", time: 0.0, velocity: 100 },
  { note: "B3", time: 0.15, velocity: 90 },
  { note: "D4", time: 0.3, velocity: 85 },
  { note: "C5", time: 0.45, velocity: 95 },
  { note: "E3", time: 0.6, velocity: 80 },
  { note: "A3", time: 0.75, velocity: 90 },
  { note: "E4", time: 0.9, velocity: 85 },
  { note: "D5", time: 1.05, velocity: 90 },

  // Cycle 2
  { note: "D3", time: 1.2, velocity: 100 },
  { note: "C4", time: 1.35, velocity: 90 },
  { note: "G4", time: 1.5, velocity: 85 },
  { note: "E5", time: 1.65, velocity: 95 },
  { note: "C3", time: 1.8, velocity: 80 },
  { note: "B3", time: 1.95, velocity: 90 },
  { note: "A4", time: 2.1, velocity: 85 },
  { note: "G5", time: 2.25, velocity: 90 },

  // Cycle 3
  { note: "G3", time: 2.4, velocity: 100 },
  { note: "A3", time: 2.55, velocity: 90 },
  { note: "D4", time: 2.7, velocity: 85 },
  { note: "A5", time: 2.85, velocity: 95 },
  { note: "E3", time: 3.0, velocity: 80 },
  { note: "B3", time: 3.15, velocity: 90 },
  { note: "E4", time: 3.3, velocity: 85 },
  { note: "B5", time: 3.45, velocity: 90 },

  // Cycle 4
  { note: "D3", time: 3.6, velocity: 100 },
  { note: "C4", time: 3.75, velocity: 90 },
  { note: "G4", time: 3.9, velocity: 85 },
  { note: "C5", time: 4.05, velocity: 95 },
  { note: "G2", time: 4.2, velocity: 85 },
  { note: "A3", time: 4.35, velocity: 90 },
  { note: "B4", time: 4.5, velocity: 85 },
  { note: "D5", time: 4.65, velocity: 90 },
];

// Kariga Mombe - traditional piece about cattle
const KARIGA_MOMBE: SongNote[] = [
  // Pattern 1
  { note: "G2", time: 0.0, velocity: 100 },
  { note: "B3", time: 0.12, velocity: 85 },
  { note: "D5", time: 0.24, velocity: 90 },
  { note: "A2", time: 0.4, velocity: 95 },
  { note: "C4", time: 0.52, velocity: 85 },
  { note: "E5", time: 0.64, velocity: 90 },
  { note: "B2", time: 0.8, velocity: 100 },
  { note: "D4", time: 0.92, velocity: 85 },
  { note: "G5", time: 1.04, velocity: 90 },

  // Pattern 2
  { note: "C3", time: 1.2, velocity: 100 },
  { note: "E4", time: 1.32, velocity: 85 },
  { note: "A5", time: 1.44, velocity: 90 },
  { note: "D3", time: 1.6, velocity: 95 },
  { note: "G4", time: 1.72, velocity: 85 },
  { note: "B5", time: 1.84, velocity: 90 },
  { note: "E3", time: 2.0, velocity: 100 },
  { note: "A4", time: 2.12, velocity: 85 },
  { note: "C5", time: 2.24, velocity: 90 },

  // Pattern 3
  { note: "G3", time: 2.4, velocity: 100 },
  { note: "B4", time: 2.52, velocity: 85 },
  { note: "D5", time: 2.64, velocity: 90 },
  { note: "A2", time: 2.8, velocity: 95 },
  { note: "C4", time: 2.92, velocity: 85 },
  { note: "E5", time: 3.04, velocity: 90 },
  { note: "G2", time: 3.2, velocity: 100 },
  { note: "D4", time: 3.32, velocity: 85 },
  { note: "G5", time: 3.44, velocity: 95 },
];

export const SONGS: Song[] = [
  { id: "nhemamusasa", title: "Nhemamusasa", notes: NHEMAMUSASA },
  { id: "kariga-mombe", title: "Kariga Mombe", notes: KARIGA_MOMBE },
];
